// removed by extract-text-webpack-plugin
module.exports = {"textLogo":"src-components-TextLogo----text-logo-module---textLogo---3OHli","textLogoLight":"src-components-TextLogo----text-logo-module---textLogoLight---1fHfZ","textLogoDark":"src-components-TextLogo----text-logo-module---textLogoDark---2S59o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextLogo/text-logo.module.scss
// module id = 344
// module chunks = 168707334958949